import { render } from "./MainObjectives.vue?vue&type=template&id=f2323cb6"
import script from "./MainObjectives.vue?vue&type=script&lang=js"
export * from "./MainObjectives.vue?vue&type=script&lang=js"

import "./MainObjectives.vue?vue&type=style&index=0&id=f2323cb6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__